"use client";

import { ParallaxProvider as Parallax } from "react-scroll-parallax";

export const ParallaxProvider = ({ children }: { children: React.ReactNode }) => {
  return <Parallax>{children}</Parallax>;
};
